import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }
const _hoisted_2 = { class: "custom-padding-30" }
const _hoisted_3 = {
  class: "bg-body-bg p-3 rounded-3",
  style: {"margin-top":"2px"}
}
const _hoisted_4 = { class: "d-flex flex-wrap gap-1 justify-content-between mb-1" }
const _hoisted_5 = { class: "text-secondary fs-16 fw-medium" }
const _hoisted_6 = { class: "d-flex flex-wrap gap-1 justify-content-between" }
const _hoisted_7 = { class: "text-secondary d-flex align-items-center" }
const _hoisted_8 = { class: "text-secondary d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-1 pb-3" }, [
        _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Upcoming Events"),
        _createElementVNode("div", {
          class: "swiper-pagination-upcoming-events text-end",
          style: {"width":"100px"}
        })
      ], -1)),
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 25,
        loop: false,
        centeredSlides: false,
        preventClicks: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.swiper-pagination-upcoming-events',
          clickable: true,
        },
        modules: _ctx.modules,
        class: "upcoming-events-slide-two"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              class: "cursor",
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1),
                    _createElementVNode("span", null, _toDisplayString(item.date), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-time-line fs-16 me-2" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.time), 1)
                    ]),
                    _createElementVNode("span", _hoisted_8, [
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-map-pin-line fs-16 me-2" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(item.location), 1)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}